import { CommonModule } from '@angular/common';
import { IDS_FORM_PARAMS } from './../shared-active-scan-form.component';
import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { BaseComponent } from '@ids-components';
import { FormBuilderComponent } from '@microsec/components';
import { DOCUMENTATION_URL, DOMAIN, DOMAIN_TOKEN } from '@microsec/constants';
import { FormItem } from '@microsec/models';

@Component({
  selector: 'app-sas-form-advanced-config',
  templateUrl: './sas-form-advanced-config.component.html',
  styleUrls: ['./sas-form-advanced-config.component.scss'],
  imports: [CommonModule, FormBuilderComponent],
})
export class SasFormAdvancedConfigComponent extends BaseComponent implements AfterViewInit {
  fields: FormItem[] = [];

  showConfig = false;

  @ViewChild('fb') form!: FormBuilderComponent;

  ngAfterViewInit(): void {
    this.initForm();
  }

  initForm() {
    const fields: FormItem[] = [
      Object.assign(new FormItem(), {
        name: IDS_FORM_PARAMS.MAX_SCAN_RATE,
        label: 'Max Scan Rate (packet/s)',
        field: 'number',
        fieldInfo:
          'Set to avoid overwhelming the network and reduce the chance of packet loss, while achieving faster results. This will control the bandwidth that the scan will take.',
        placeholder: 'Input Max Scan Rate (e.g. 2000)',
        defaultValue: 2000,
        minValue: 0,
        required: true,
        hidden: false,
      } as FormItem),
      Object.assign(new FormItem(), {
        name: IDS_FORM_PARAMS.MIN_SCAN_RATE,
        label: 'Min Scan Rate (packet/s)',
        field: 'number',
        fieldInfo:
          'Sets mininum packet-per-second rate to avoid excessively slow scans. Increasing this rate can shorten scan time but may lead to incomplete results in networks with limited bandwidth.',
        placeholder: 'Input Min Scan Rate (e.g. 1000)',
        defaultValue: 1000,
        minValue: 0,
        required: true,
        hidden: false,
      } as FormItem),
      Object.assign(new FormItem(), {
        name: IDS_FORM_PARAMS.DELAY_TIME,
        label: 'Delay Time (ms)',
        field: 'number',
        fieldInfo: 'Adds a pause between each probe, reducing network load but slowing down the scan.',
        placeholder: 'Input Delay Time (e.g. 100)',
        defaultValue: 100,
        minValue: 0,
        required: true,
        hidden: false,
      } as FormItem),
      Object.assign(new FormItem(), {
        name: IDS_FORM_PARAMS.TIMEOUT,
        label: 'Timeout (ms)',
        field: 'number',
        fieldInfo: 'Sets the wait time for a response before marking a probe as failed. Higher timeouts suit slow networks but increase scan time.',
        placeholder: 'Input Delay Time (e.g. 1000)',
        defaultValue: 1000,
        maxValue: 120000,
        minValue: 0,
        required: true,
        hidden: false,
      } as FormItem),
      Object.assign(new FormItem(), {
        name: IDS_FORM_PARAMS.MAX_RETRY_NUMBER,
        label: 'Max Retry Number',
        field: 'number',
        fieldInfo:
          'limits how many times a probe will be resend if no response is received. Higher retries improve accuracy on unreliable networks but slow down the scan.',
        placeholder: 'Input Max Retry Number (e.g. 1)',
        defaultValue: 1,
        minValue: 0,
        required: true,
        hidden: false,
      } as FormItem),
      Object.assign(new FormItem(), {
        name: IDS_FORM_PARAMS.SCAN_COMMANDS,
        label: 'Custom Scan Commands',
        required: false,
        field: 'input',
        fieldInfo: 'Enter specific commands to customise the nmap scan. Refer to the Command Documentation Guide for supported options.',
        placeholder: '-sS -sU',
        defaultValue: '',
      } as FormItem),
      Object.assign(new FormItem(), {
        hasNoLabel: true,
        rowStyleClass: 'text-left -mt-5',
        field: 'link',
        url: (DOCUMENTATION_URL + 'usage/03_devices.html#supported-advanced-custom-active-scan-inputs').replace(
          DOMAIN_TOKEN,
          localStorage.getItem(DOMAIN) || '',
        ),
        defaultValue: 'Command Documentation Guide',
      } as FormItem),
    ];
    fields.forEach((field) => {
      field.isMediumSize = true;
    });
    this.fields = fields;
  }
}
